const API_BASE = '/api';

async function get<T>(path: string, params?: Record<string, string | number | undefined>): Promise<T> {
  const url = new URL(API_BASE + path, window.location.origin);
  if (params) {
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null) url.searchParams.set(k, String(v));
    });
  }
  const r = await fetch(url.toString());
  if (!r.ok) throw new Error(`API ${path} → HTTP ${r.status}`);
  return r.json() as Promise<T>;
}

export const api = {
  vector: (target: string, start: string, stop: string, step = '1d') =>
    get<unknown>('/ephemeris/vector', { target, start, stop, step }),
  search: (params: Record<string, string | number>) => get<unknown>('/objects/search', params),
  planet9Samples: (n = 1000, seed?: number) => get<unknown>('/planet9/samples', { n, seed }),
  planet9SkyMap: (tile_size_deg = 2) => get<unknown>('/planet9/sky-map', { tile_size_deg }),
  sourcesStatus: () => get<unknown>('/sources/status'),
};
